(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2971],{

/***/ 99204:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/questions",
      function () {
        return __webpack_require__(74151);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ CompaniesAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24196);



var getCompanies = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/companies")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getCompanies() {
        return _ref.apply(this, arguments);
    };
}();
var getTopCompanies = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/companies/top")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getTopCompanies() {
        return _ref.apply(this, arguments);
    };
}();
var getRecentCompanies = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/companies/recent")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getRecentCompanies() {
        return _ref.apply(this, arguments);
    };
}();
var getCompany = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/companies/detail/".concat(slug))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getCompany(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getInterviewGuides = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(slug) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* .API.get */ .b.get("/v1/companies/interview-guides/".concat(slug))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getInterviewGuides(slug) {
        return _ref.apply(this, arguments);
    };
}();
var CompaniesAPI = {
    getCompanies: getCompanies,
    getTopCompanies: getTopCompanies,
    getRecentCompanies: getRecentCompanies,
    getCompany: getCompany,
    getInterviewGuides: getInterviewGuides
};


/***/ }),

/***/ 84476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ AcceptanceRate; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _acceptance_rate_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33082);
/* harmony import */ var _acceptance_rate_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_acceptance_rate_module_css__WEBPACK_IMPORTED_MODULE_1__);


var AcceptanceRate = function(param) {
    var value = param.value;
    if (!value) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: (_acceptance_rate_module_css__WEBPACK_IMPORTED_MODULE_1___default().na),
            children: "N/A"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            Math.round(value * 100),
            "%"
        ]
    });
};


/***/ }),

/***/ 42865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ QuestionTablePaginator; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_system_paginator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2270);
/* harmony import */ var components_system_select__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11205);
/* harmony import */ var utils_question_list__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73696);
/* harmony import */ var _question_table_paginator_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70280);
/* harmony import */ var _question_table_paginator_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_question_table_paginator_module_css__WEBPACK_IMPORTED_MODULE_4__);







var QuestionTablePaginator = function(param) {
    var questions = param.questions, config = param.config, onConfigChange = param.onConfigChange;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_question_table_paginator_module_css__WEBPACK_IMPORTED_MODULE_4___default().paginator),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_paginator__WEBPACK_IMPORTED_MODULE_1__/* .Paginator */ .D, {
                page: config.page,
                pageSize: config.pageSize,
                totalItems: questions.length,
                onChange: function(page) {
                    return onConfigChange((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, config), {
                        page: page
                    }));
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_select__WEBPACK_IMPORTED_MODULE_2__/* .Select */ .P, {
                size: "sm",
                placeholder: "Questions per page",
                options: utils_question_list__WEBPACK_IMPORTED_MODULE_3__/* .pageSizeOptions */ .Wv,
                value: config.pageSize,
                onChange: function(pageSize) {
                    return onConfigChange((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, config), {
                        page: 0,
                        pageSize: pageSize
                    }));
                }
            })
        ]
    });
};


/***/ }),

/***/ 87834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ QuestionLink; },
/* harmony export */   "l": function() { return /* binding */ QuestionLinkList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var api_tracking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5123);
/* harmony import */ var components_system_pilltag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94390);
/* harmony import */ var components_system_pilltag_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8681);
/* harmony import */ var icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63009);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var types_levels__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38194);
/* harmony import */ var _question_link_list_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85285);
/* harmony import */ var _question_link_list_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_question_link_list_module_css__WEBPACK_IMPORTED_MODULE_7__);









var QuestionLinkList = function(param) {
    var questions = param.questions, trackingComponent = param.trackingComponent, trackingExtraData = param.trackingExtraData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_question_link_list_module_css__WEBPACK_IMPORTED_MODULE_7___default().container),
        children: questions.map(function(question, ranking) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuestionLink, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                ranking: ranking,
                trackingComponent: trackingComponent,
                trackingExtraData: trackingExtraData
            }, question), question.slug);
        })
    });
};
var QuestionLink = function(param) {
    var uuid = param.uuid, slug = param.slug, title = param.title, summary = param.summary, tags = param.tags, level = param.level, ranking = param.ranking, trackingComponent = param.trackingComponent, trackingExtraData = param.trackingExtraData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
        prefetch: false,
        href: "/questions/".concat(slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: (_question_link_list_module_css__WEBPACK_IMPORTED_MODULE_7___default().link),
            onClick: function() {
                api_tracking__WEBPACK_IMPORTED_MODULE_1__/* .TrackingAPI.recommendedQuestionClicked */ .A.recommendedQuestionClicked({
                    ranking: ranking,
                    uuid: uuid,
                    component: trackingComponent,
                    extraData: trackingExtraData
                });
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_question_link_list_module_css__WEBPACK_IMPORTED_MODULE_7___default().content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            children: title
                        }),
                        summary && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: summary
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_system_pilltag_group__WEBPACK_IMPORTED_MODULE_3__/* .PillTagGroup */ .s, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_pilltag__WEBPACK_IMPORTED_MODULE_2__/* .PillTag */ .j, {
                                    color: types_levels__WEBPACK_IMPORTED_MODULE_6__/* .difficultyLevelColors */ .gw[level],
                                    children: types_levels__WEBPACK_IMPORTED_MODULE_6__/* .difficultyLevelNames */ .vz[level]
                                }),
                                (tags || []).map(function(tag) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_system_pilltag__WEBPACK_IMPORTED_MODULE_2__/* .PillTag */ .j, {
                                        color: "greyLight",
                                        children: tag.name
                                    }, tag.id);
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(icons__WEBPACK_IMPORTED_MODULE_4__/* .ChevronRightIcon */ .XC, {})
            ]
        })
    });
};


/***/ }),

/***/ 62836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ContentPlaceholder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _content_placeholder_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5306);
/* harmony import */ var _content_placeholder_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_content_placeholder_module_css__WEBPACK_IMPORTED_MODULE_1__);



var ContentPlaceholder = function(param) {
    var _lines = param.lines, lines = _lines === void 0 ? 5 : _lines;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_content_placeholder_module_css__WEBPACK_IMPORTED_MODULE_1___default().container),
        children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Array(lines).keys()).map(function(_, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_content_placeholder_module_css__WEBPACK_IMPORTED_MODULE_1___default().line)
            }, index);
        })
    });
};


/***/ }),

/***/ 34724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ DifficultyLevel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var types_levels__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38194);
/* harmony import */ var _pilltag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94390);




var DifficultyLevel = function(param) {
    var level = param.level, extra = param.extra;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pilltag__WEBPACK_IMPORTED_MODULE_3__/* .PillTag */ .j, {
        color: types_levels__WEBPACK_IMPORTED_MODULE_2__/* .difficultyLevelColors */ .gw[level],
        children: [
            types_levels__WEBPACK_IMPORTED_MODULE_2__/* .difficultyLevelNames */ .vz[level],
            extra ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    ": ",
                    extra
                ]
            }) : null
        ]
    });
};


/***/ }),

/***/ 34070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44868);
/* harmony import */ var _divider_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45062);
/* harmony import */ var _divider_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_divider_module_css__WEBPACK_IMPORTED_MODULE_2__);




var Divider = function(param) {
    var maxWidth = param.maxWidth, _size = param.size, size = _size === void 0 ? "md" : _size, _align = param.align, align = _align === void 0 ? "center" : _align, children = param.children;
    var style = {
        maxWidth: maxWidth ? maxWidth : undefined,
        margin: "var(--iq-gap-".concat(size, ") auto")
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_divider_module_css__WEBPACK_IMPORTED_MODULE_2___default().divider),
        style: style,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (0,utils__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .AK)([
                (_divider_module_css__WEBPACK_IMPORTED_MODULE_2___default().children),
                (_divider_module_css__WEBPACK_IMPORTED_MODULE_2___default())[size],
                (_divider_module_css__WEBPACK_IMPORTED_MODULE_2___default())[align]
            ]),
            children: children
        })
    });
};


/***/ }),

/***/ 89795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Latex; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var katex_dist_katex_min_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97604);
/* harmony import */ var katex_dist_katex_min_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(katex_dist_katex_min_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_latex_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30760);




var Latex = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_latex_next__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
};


/***/ }),

/***/ 8681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ PillTagGroup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pilltag_group_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12195);
/* harmony import */ var _pilltag_group_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_pilltag_group_module_css__WEBPACK_IMPORTED_MODULE_2__);



var PillTagGroup = function(param) {
    var children = param.children, maxVisible = param.maxVisible;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), viewAll = ref[0], setViewAll = ref[1];
    var count = react__WEBPACK_IMPORTED_MODULE_1__.Children.count(children);
    var visible = maxVisible || count;
    var extra = Math.max(0, count - visible);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_pilltag_group_module_css__WEBPACK_IMPORTED_MODULE_2___default().pilltagGroup),
        children: [
            viewAll ? children : react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children).slice(0, visible),
            extra > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: (_pilltag_group_module_css__WEBPACK_IMPORTED_MODULE_2___default().viewAll),
                onClick: function() {
                    return setViewAll(viewAll ? false : true);
                },
                children: viewAll ? "show less" : "+".concat(extra, " more")
            })
        ]
    });
};


/***/ }),

/***/ 12074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Sticky; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var hooks_is_mobile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77963);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44868);
/* harmony import */ var _sticky_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82912);
/* harmony import */ var _sticky_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_sticky_module_css__WEBPACK_IMPORTED_MODULE_4__);





var HEADER_HEIGHT = 80;
var Sticky = function(param) {
    var _threshold = param.threshold, threshold = _threshold === void 0 ? 20 : _threshold, _shadow = param.shadow, shadow = _shadow === void 0 ? false : _shadow, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _zIndexOffset = param.zIndexOffset, zIndexOffset = _zIndexOffset === void 0 ? 0 : _zIndexOffset, children = param.children;
    var isMobile = (0,hooks_is_mobile__WEBPACK_IMPORTED_MODULE_1__/* .useIsMobile */ .d)();
    if (disabled) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            top: (isMobile ? 0 : HEADER_HEIGHT) + threshold,
            zIndex: "calc(var(--iq-z-index-sticky) + ".concat(zIndexOffset, ")")
        },
        className: (0,utils__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .AK)([
            (_sticky_module_css__WEBPACK_IMPORTED_MODULE_4___default().sticky),
            shadow && (_sticky_module_css__WEBPACK_IMPORTED_MODULE_4___default().hasShadow)
        ]),
        children: [
            children,
            shadow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            height: threshold
                        },
                        className: (_sticky_module_css__WEBPACK_IMPORTED_MODULE_4___default().topShadow)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            height: threshold
                        },
                        className: (_sticky_module_css__WEBPACK_IMPORTED_MODULE_4___default().bottomShadow)
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 74151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_questions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/api/tracking.ts
var tracking = __webpack_require__(5123);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/components/seo.tsx + 1 modules
var seo = __webpack_require__(22821);
// EXTERNAL MODULE: ./src/components/system/button.tsx
var system_button = __webpack_require__(4642);
// EXTERNAL MODULE: ./src/components/system/divider.tsx
var divider = __webpack_require__(34070);
// EXTERNAL MODULE: ./src/components/system/sticky.tsx
var sticky = __webpack_require__(12074);
// EXTERNAL MODULE: ./src/components/system/text_input.tsx
var text_input = __webpack_require__(29838);
// EXTERNAL MODULE: ./src/hooks/is_mobile.tsx
var is_mobile = __webpack_require__(77963);
// EXTERNAL MODULE: ./src/hooks/local_storage_state.tsx
var local_storage_state = __webpack_require__(87639);
// EXTERNAL MODULE: ./src/hooks/query_string_state.tsx
var query_string_state = __webpack_require__(75921);
// EXTERNAL MODULE: ./src/icons/index.tsx + 61 modules
var icons = __webpack_require__(63009);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/users/index.tsx
var users = __webpack_require__(86593);
// EXTERNAL MODULE: ./src/utils/question_list.tsx
var question_list = __webpack_require__(73696);
// EXTERNAL MODULE: ./src/components/questions/recommended_questions.tsx
var recommended_questions = __webpack_require__(61895);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/icons/lock.tsx
var lock = __webpack_require__(64239);
// EXTERNAL MODULE: ./src/components/questions/list/categories.module.css
var categories_module = __webpack_require__(51606);
var categories_module_default = /*#__PURE__*/__webpack_require__.n(categories_module);
;// CONCATENATED MODULE: ./src/components/questions/list/categories.tsx








var Categories = function(param) {
    var categories = param.categories, config = param.config, onConfigChange = param.onConfigChange;
    var showUpsellModal = (0,users/* useUpsell */.$n)().showUpsellModal;
    // A category is considered selected if all of its tags are selected.
    var selectedCategories = categories.filter(function(category) {
        return category.question_tags.every(function(tag) {
            return config.tags.includes(tag.name);
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (categories_module_default()).container,
        children: categories.map(function(category) {
            // Is the current category selected?
            var selected = selectedCategories.includes(category);
            // Current category tag names,
            var categoryTags = category.question_tags.map(function(tag) {
                return tag.name;
            });
            // The tags to remove when unselecting this category.
            // This reduces to all of the category tags except any shared tags with another selected category.
            var tagsToRemove = selected ? categoryTags.filter(function(tag) {
                return selectedCategories.every(function(selectedCategory) {
                    return selectedCategory === category || !selectedCategory.question_tags.map(function(tag) {
                        return tag.name;
                    }).includes(tag);
                });
            }) : [];
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
                color: selected ? "orange" : "greyLight",
                type: "fill",
                size: "sm",
                icon: category.locked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lock/* LockIcon */.m, {}) : null,
                onClick: function() {
                    if (category.locked) {
                        showUpsellModal({
                            cta: "question.locked"
                        });
                    } else {
                        onConfigChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                            tags: selected ? config.tags.filter(function(tag) {
                                return !tagsToRemove.includes(tag);
                            }) : (0,_to_consumable_array/* default */.Z)(new Set((0,_to_consumable_array/* default */.Z)(config.tags).concat((0,_to_consumable_array/* default */.Z)(categoryTags))))
                        }));
                    }
                },
                children: category.name
            }, category.id);
        })
    });
};

// EXTERNAL MODULE: ./src/components/questions/list/question_counts.module.css
var question_counts_module = __webpack_require__(87642);
var question_counts_module_default = /*#__PURE__*/__webpack_require__.n(question_counts_module);
;// CONCATENATED MODULE: ./src/components/questions/list/question_counts.tsx




var QuestionCounts = function(param) {
    var questions = param.questions, visibleQuestions = param.visibleQuestions;
    var ref = (0,users/* useAuth */.aC)(), user = ref.user, isReady = ref.isReady, hasPermission = ref.hasPermission;
    var ref1 = (0,react.useMemo)(function() {
        var companyCounter = {};
        var positionCounter = {};
        questions.forEach(function(question) {
            question.companies.forEach(function(company) {
                return companyCounter[company.company] = true;
            });
            question.positions.forEach(function(position) {
                return positionCounter[position.position] = true;
            });
        });
        var companies_response = "";
        if (user && user.loggedIn && isReady && hasPermission("question_company_filter")) {
            companies_response = "from ".concat(Object.keys(companyCounter).length, " compan").concat(Object.keys(companyCounter).length === 1 ? "y" : "ies");
        }
        return [
            companies_response,
            " for ".concat(Object.keys(positionCounter).length, " position").concat(Object.keys(positionCounter).length === 1 ? "" : "s"), 
        ];
    }, [
        questions
    ]), companies = ref1[0], positions = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: (question_counts_module_default()).counts,
        children: [
            visibleQuestions.length === questions.length ? "Showing ".concat(questions.length) : "Showing only ".concat(visibleQuestions.length, " of ").concat(questions.length),
            " ",
            "interview questions ",
            companies,
            positions,
            "."
        ]
    });
};

// EXTERNAL MODULE: ./src/components/questions/list/question_list.module.css
var question_list_module = __webpack_require__(16493);
var question_list_module_default = /*#__PURE__*/__webpack_require__.n(question_list_module);
// EXTERNAL MODULE: ./src/components/system/help_tooltip.tsx + 1 modules
var help_tooltip = __webpack_require__(96914);
// EXTERNAL MODULE: ./src/types/questions.ts
var types_questions = __webpack_require__(409);
// EXTERNAL MODULE: ./src/api/questions.ts
var questions = __webpack_require__(6505);
// EXTERNAL MODULE: ./src/components/questions/acceptance_rate.tsx
var acceptance_rate = __webpack_require__(84476);
// EXTERNAL MODULE: ./src/components/system/async_button.tsx
var async_button = __webpack_require__(81715);
// EXTERNAL MODULE: ./src/components/system/difficulty_level.tsx
var difficulty_level = __webpack_require__(34724);
// EXTERNAL MODULE: ./src/components/system/pilltag.tsx
var pilltag = __webpack_require__(94390);
// EXTERNAL MODULE: ./src/components/system/pilltag_group.tsx
var pilltag_group = __webpack_require__(8681);
// EXTERNAL MODULE: ./src/components/system/tooltip.tsx
var tooltip = __webpack_require__(45821);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/components/system/latex.tsx
var latex = __webpack_require__(89795);
// EXTERNAL MODULE: ./src/components/system/spinner.tsx
var spinner = __webpack_require__(52852);
// EXTERNAL MODULE: ./src/components/system/text_container.tsx
var text_container = __webpack_require__(70865);
// EXTERNAL MODULE: ./src/hooks/outside_click.tsx
var outside_click = __webpack_require__(81159);
// EXTERNAL MODULE: ./src/utils/index.tsx
var utils = __webpack_require__(44868);
// EXTERNAL MODULE: ./src/components/questions/list/question_preview.module.css
var question_preview_module = __webpack_require__(14339);
var question_preview_module_default = /*#__PURE__*/__webpack_require__.n(question_preview_module);
;// CONCATENATED MODULE: ./src/components/questions/list/question_preview.tsx














var QuestionPreview = function(param) {
    var question = param.question, onChange = param.onChange;
    var ref = (0,react.useState)(false), loadingPreview = ref[0], setLoadingPreview = ref[1];
    var ref1 = (0,react.useState)(null), questionPreview = ref1[0], setQuestionPreview = ref1[1];
    var ref2 = (0,react.useState)(false), animate = ref2[0], setAnimate = ref2[1];
    (0,react.useEffect)(function() {
        tracking/* TrackingAPI.questionPreview */.A.questionPreview(question.uuid);
        setAnimate(true);
    }, [
        question
    ]);
    var node = (0,react.useRef)(null);
    (0,outside_click/* useOutsideClick */.O)(node.current, function() {
        // This hurts my programmer soul.
        onChange("aaa");
    });
    (0,react.useEffect)(function() {
        if (!questionPreview) {
            var getQuestionDetails = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var questionPreviewData;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                setLoadingPreview(true);
                                return [
                                    4,
                                    questions/* QuestionsAPI.getQuestionPreview */.m.getQuestionPreview(question.slug)
                                ];
                            case 1:
                                questionPreviewData = _state.sent();
                                if (questionPreviewData.error) {
                                    return [
                                        2
                                    ];
                                }
                                setLoadingPreview(false);
                                setQuestionPreview(questionPreviewData);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function getQuestionDetails() {
                    return _ref.apply(this, arguments);
                };
            }();
            getQuestionDetails();
        }
    }, [
        question
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: node,
        "data-question-preview": question.slug,
        className: (0,utils/* classNames */.AK)([
            (question_preview_module_default()).questionContainerPreview,
            animate && (question_preview_module_default()).hoverLink
        ]),
        children: [
            loadingPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* Spinner */.$, {
                text: "loading question preview",
                size: "sm"
            }),
            questionPreview && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (question_preview_module_default()).modalContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (question_preview_module_default()).upper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (question_preview_module_default()).modalHeader,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: questionPreview.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
                                        title: "Close preview",
                                        type: "icon",
                                        onClick: function() {
                                            return onChange("");
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (question_preview_module_default()).questionBodyPreview,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_container/* TextContainer */.l, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(latex/* Latex */.r, {
                                        children: questionPreview.body
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (question_preview_module_default()).navigate,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Access the full question details, submit your answer, and more."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (question_preview_module_default()).buttons,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
                                        color: "blue",
                                        size: "md",
                                        href: "/questions/".concat(question.slug),
                                        children: "Answer question"
                                    }),
                                    question.has_solution && /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
                                        color: "orange",
                                        size: "md",
                                        href: "/questions/".concat(question.slug, "?solution=true"),
                                        children: "Show solution"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var question_preview = (QuestionPreview);

// EXTERNAL MODULE: ./src/components/questions/list/question_row.module.css
var question_row_module = __webpack_require__(58435);
var question_row_module_default = /*#__PURE__*/__webpack_require__.n(question_row_module);
;// CONCATENATED MODULE: ./src/components/questions/list/question_row.tsx





















var QuestionRow = function(param) {
    var question = param.question, onQuestionChange = param.onQuestionChange, config = param.config, onConfigChange = param.onConfigChange, onChangePreview = param.onChangePreview, showPreview = param.showPreview, ranking = param.ranking;
    var isMobile = (0,is_mobile/* useIsMobile */.d)();
    var hasPermission = (0,users/* useAuth */.aC)().hasPermission;
    var loginRequired = (0,users/* useUpsell */.$n)().loginRequired;
    var hoverState = (0,react.useRef)(false);
    var handleTagClick = function(tag) {
        if (config.tags.includes(tag)) {
            onConfigChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                tags: config.tags.filter(function(c) {
                    return c !== tag;
                }),
                page: 0
            }));
        } else {
            onConfigChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                tags: (0,_to_consumable_array/* default */.Z)(config.tags).concat([
                    tag
                ]),
                page: 0
            }));
        }
    };
    var handleCompanyClick = function(company) {
        if (config.companies.includes(company)) {
            onConfigChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                companies: config.companies.filter(function(c) {
                    return c !== company;
                }),
                page: 0
            }));
        } else {
            onConfigChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                companies: (0,_to_consumable_array/* default */.Z)(config.companies).concat([
                    company
                ]),
                page: 0
            }));
        }
    };
    var link = /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        prefetch: false,
        href: "/questions/".concat(question.slug),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (question_row_module_default()).link,
            onMouseOver: function() {
                hoverState.current = true;
                setTimeout(function() {
                    if (hoverState.current) {
                        onChangePreview(question.slug);
                    }
                }, 500);
            },
            onMouseOut: function() {
                hoverState.current = false;
            },
            onClick: function(e) {
                hoverState.current = false;
                // Only track recommendation clicked if using the default ordering which is
                // based on the recommender.
                if (config.ordering === question_list/* defaultQuestionListConfig.ordering */.qT.ordering) {
                    tracking/* TrackingAPI.recommendedQuestionClicked */.A.recommendedQuestionClicked({
                        uuid: question.uuid,
                        ranking: ranking,
                        component: "questionList"
                    });
                }
            },
            children: question.title
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
        className: (question_row_module_default()).row,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        link,
                        showPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(question_preview, {
                            question: question,
                            onChange: function(question_slug) {
                                onChangePreview(question_slug);
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: (question_row_module_default()).score,
                children: question.upvotes < 0 ? 0 : question.upvotes
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pilltag_group/* PillTagGroup */.s, {
                    maxVisible: isMobile ? 1 : 2,
                    children: question.tags.sort(function(a, b) {
                        //sort first buy primary
                        return a.is_primary && !b.is_primary ? -1 : 1;
                    }).sort(function(a, b) {
                        var ref, ref1;
                        //then by selected (more important)
                        return ((ref = config.tags) === null || ref === void 0 ? void 0 : ref.includes(a.name)) && !((ref1 = config.tags) === null || ref1 === void 0 ? void 0 : ref1.includes(b.name)) ? -1 : 1;
                    }).map(function(tag) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(pilltag/* PillTag */.j, {
                            color: ((ref = config.tags) === null || ref === void 0 ? void 0 : ref.includes(tag.name)) ? "blue" : "greyLight",
                            onClick: function() {
                                return handleTagClick(tag.name);
                            },
                            children: tag.name
                        }, tag.name);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: (question_row_module_default()).companies,
                children: hasPermission("question_company_view") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pilltag_group/* PillTagGroup */.s, {
                    maxVisible: isMobile ? 1 : 2,
                    children: question.companies.map(function(param) {
                        var company = param.company;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(pilltag/* PillTag */.j, {
                            maxTextLength: isMobile ? 50 : 10,
                            color: config.companies.includes(company) ? "blue" : "greyLight",
                            onClick: function() {
                                return handleCompanyClick(company);
                            },
                            children: company
                        }, company);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (question_row_module_default()).hasIcon,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lock/* LockIcon */.m, {}),
                        " Locked"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(difficulty_level/* DifficultyLevel */.Q, {
                    level: question.level
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(acceptance_rate/* AcceptanceRate */.n, {
                    value: question.acceptance_rate
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (question_row_module_default()).actions,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                            tipText: question.saved ? "Unsave question" : "Save question",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(async_button/* AsyncButton */.Z, {
                                title: question.saved ? "Unsave question" : "Save question",
                                name: "saveQuestion",
                                type: "icon",
                                allowClick: loginRequired({
                                    sourceObject: question,
                                    cta: "question.save"
                                }),
                                onRequest: function() {
                                    return questions/* QuestionsAPI.saveQuestion */.m.saveQuestion(question.slug, !question.saved);
                                },
                                onSuccess: function() {
                                    return onQuestionChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, question), {
                                        saved: !question.saved
                                    }));
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* StarIcon */.r7, {
                                    color: question.saved ? "orange" : "greyLight"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                            tipText: question.completed ? "Mark as uncompleted" : "Mark as completed",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(async_button/* AsyncButton */.Z, {
                                title: question.completed ? "Mark as uncompleted" : "Mark as completed",
                                name: "markCompleted",
                                type: "icon",
                                allowClick: loginRequired({
                                    sourceObject: question,
                                    cta: "question.markCompleted"
                                }),
                                onRequest: function() {
                                    return questions/* QuestionsAPI.markCompleted */.m.markCompleted(question.slug, !question.completed);
                                },
                                onSuccess: function() {
                                    return onQuestionChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, question), {
                                        completed: !question.completed
                                    }));
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckmarkIcon */.KM, {
                                    color: question.completed ? "blueLight" : "greyLight"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/questions/list/question_table.module.css
var question_table_module = __webpack_require__(2503);
var question_table_module_default = /*#__PURE__*/__webpack_require__.n(question_table_module);
;// CONCATENATED MODULE: ./src/components/questions/list/question_table.tsx









var QuestionTable = function(param) {
    var questions = param.questions, onQuestionChange = param.onQuestionChange, config = param.config, onConfigChange = param.onConfigChange;
    var ref = (0,react.useState)(""), hoverQuestionSlug = ref[0], setHoverQuestionSlug = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (question_table_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
            className: (question_table_module_default()).table,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                scope: "col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderBy, {
                                    label: "Title",
                                    orderKey: types_questions/* QuestionListOrdering.Title */.iM.Title,
                                    firstDirection: types_questions/* QuestionListOrderingDirection.ASC */._m.ASC,
                                    config: config,
                                    onConfigChange: onConfigChange
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                scope: "col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderBy, {
                                    label: "Score",
                                    orderKey: types_questions/* QuestionListOrdering.Score */.iM.Score,
                                    firstDirection: types_questions/* QuestionListOrderingDirection.DESC */._m.DESC,
                                    config: config,
                                    onConfigChange: onConfigChange
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                scope: "col",
                                children: "Tags"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                scope: "col",
                                children: "Company"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                scope: "col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderBy, {
                                    label: "Difficulty",
                                    orderKey: types_questions/* QuestionListOrdering.Difficulty */.iM.Difficulty,
                                    firstDirection: types_questions/* QuestionListOrderingDirection.ASC */._m.ASC,
                                    config: config,
                                    onConfigChange: onConfigChange
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                scope: "col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderBy, {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (question_table_module_default()).tooltipHeader,
                                        children: [
                                            "Success ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(help_tooltip/* HelpTooltip */.k, {
                                                type: "SUCCESS"
                                            })
                                        ]
                                    }),
                                    orderKey: types_questions/* QuestionListOrdering.SuccessRate */.iM.SuccessRate,
                                    firstDirection: types_questions/* QuestionListOrderingDirection.DESC */._m.DESC,
                                    config: config,
                                    onConfigChange: onConfigChange
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: questions.map(function(question, ranking) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionRow, {
                            showPreview: question.slug === hoverQuestionSlug,
                            onChangePreview: function(slug) {
                                return setHoverQuestionSlug(slug);
                            },
                            question: question,
                            onQuestionChange: onQuestionChange,
                            config: config,
                            onConfigChange: onConfigChange,
                            ranking: ranking
                        }, question.uuid);
                    })
                })
            ]
        })
    });
};
var OrderBy = function(param) {
    var label = param.label, orderKey = param.orderKey, firstDirection = param.firstDirection, config = param.config, onConfigChange = param.onConfigChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (question_table_module_default()).orderBy,
        onClick: function() {
            if (config.ordering !== orderKey) {
                onConfigChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                    ordering: orderKey,
                    orderingDirection: firstDirection
                }));
            } else {
                if (config.orderingDirection === firstDirection) {
                    onConfigChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                        ordering: orderKey,
                        orderingDirection: firstDirection === types_questions/* QuestionListOrderingDirection.ASC */._m.ASC ? types_questions/* QuestionListOrderingDirection.DESC */._m.DESC : types_questions/* QuestionListOrderingDirection.ASC */._m.ASC
                    }));
                } else {
                    onConfigChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                        ordering: question_list/* defaultQuestionListConfig.ordering */.qT.ordering,
                        orderingDirection: question_list/* defaultQuestionListConfig.orderingDirection */.qT.orderingDirection
                    }));
                }
            }
        },
        children: [
            label,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderByArrows, {
                activeDirection: config.ordering === orderKey ? config.orderingDirection : undefined
            })
        ]
    });
};
var OrderByArrows = function(param) {
    var activeDirection = param.activeDirection;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "1em",
        height: "1em",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: activeDirection === types_questions/* QuestionListOrderingDirection.ASC */._m.ASC ? 1 : 0.3,
                d: "M18.695 9.378L12.83 3.769a1.137 1.137 0 00-.06-.054c-.489-.404-1.249-.377-1.7.06L5.303 9.381a.51.51 0 00-.16.366c0 .297.27.539.602.539h12.512a.64.64 0 00.411-.146.501.501 0 00.028-.762z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: activeDirection === types_questions/* QuestionListOrderingDirection.DESC */._m.DESC ? 1 : 0.3,
                d: "M12.77 20.285c.021-.017.042-.035.062-.054l5.863-5.609a.5.5 0 00-.028-.762.64.64 0 00-.41-.146H5.743c-.332 0-.601.242-.601.54a.51.51 0 00.16.365l5.769 5.606c.45.437 1.21.464 1.698.06z"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/questions/list/question_table_paginator.tsx
var question_table_paginator = __webpack_require__(42865);
// EXTERNAL MODULE: ./src/types/levels.ts
var levels = __webpack_require__(38194);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/components/questions/list/quick_filter.tsx






function QuickFilter(param) {
    var name = param.name, icon = param.icon, configKey = param.configKey, value = param.value, config = param.config, onConfigChange = param.onConfigChange;
    var selected = config[configKey].includes(value); // TODO: Try to remove this hack.
    var color = selected ? "orange" : "greyDark";
    var handleClick = function() {
        onConfigChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), (0,_define_property/* default */.Z)({
            page: 0
        }, configKey, selected ? [] : [
            value
        ])));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
        type: "text",
        color: color,
        icon: /*#__PURE__*/ react.cloneElement(icon, {
            color: color
        }),
        onClick: handleClick,
        children: name
    });
}

// EXTERNAL MODULE: ./src/components/questions/list/quick_filters.module.css
var quick_filters_module = __webpack_require__(7133);
var quick_filters_module_default = /*#__PURE__*/__webpack_require__.n(quick_filters_module);
;// CONCATENATED MODULE: ./src/components/questions/list/quick_filters.tsx







var QuickFilters = function(param) {
    var config = param.config, onConfigChange = param.onConfigChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (quick_filters_module_default()).quickFilters,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickFilter, {
                name: "Popular questions",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FireIcon */.Yq, {}),
                configKey: "extraFilters",
                value: types_questions/* QuestionListExtraFilter.Popular */.d0.Popular,
                config: config,
                onConfigChange: onConfigChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickFilter, {
                name: "Difficult questions",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DifficultIcon */.Yi, {}),
                configKey: "levels",
                value: levels/* difficultyLevels.Hard */.l9.Hard,
                config: config,
                onConfigChange: onConfigChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickFilter, {
                name: "New questions",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* NewIcon */.k8, {}),
                configKey: "extraFilters",
                value: types_questions/* QuestionListExtraFilter.Recent */.d0.Recent,
                config: config,
                onConfigChange: onConfigChange
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/questions/list/submit_question_button.tsx




var SubmitQuestionButton = function() {
    var user = (0,users/* useAuth */.aC)().user;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
        size: "sm",
        type: "outline",
        color: "orange",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PlusSquare */.gI, {
            color: "orange"
        }),
        href: "https://airtable.com/shrH58eRnwZh4oVWZ?prefill_Email=".concat(user.email),
        target: "_blank",
        children: "Submit a question"
    });
};

// EXTERNAL MODULE: ./src/components/system/filter_dropdown.tsx
var filter_dropdown = __webpack_require__(28172);
// EXTERNAL MODULE: ./src/components/system/checkbox.tsx
var system_checkbox = __webpack_require__(77388);
// EXTERNAL MODULE: ./src/utils/string.ts
var string = __webpack_require__(97224);
// EXTERNAL MODULE: ./src/components/system/dropdown_container.tsx
var dropdown_container = __webpack_require__(33908);
// EXTERNAL MODULE: ./src/components/system/filter_two_level_dropdown.module.css
var filter_two_level_dropdown_module = __webpack_require__(63217);
var filter_two_level_dropdown_module_default = /*#__PURE__*/__webpack_require__.n(filter_two_level_dropdown_module);
;// CONCATENATED MODULE: ./src/components/system/filter_two_level_dropdown.tsx















function FilterTwoLevelDropdown(param) {
    var placeholder = param.placeholder, topLevelOptions = param.topLevelOptions, _value = param.value, value = _value === void 0 ? [] : _value, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _enableSearch = param.enableSearch, enableSearch = _enableSearch === void 0 ? false : _enableSearch, _searchPlaceholder = param.searchPlaceholder, searchPlaceholder = _searchPlaceholder === void 0 ? "Filter options..." : _searchPlaceholder, onChange = param.onChange, allowOpen = param.allowOpen;
    var ref = (0,react.useRef)();
    var ref1 = (0,react.useState)(false), opened = ref1[0], setOpened = ref1[1];
    var ref2 = (0,react.useState)(""), searchQuery = ref2[0], setSearchQuery = ref2[1];
    var ref3 = (0,react.useState)(topLevelOptions.map(function(topLevelOption) {
        return {
            value: topLevelOption.value,
            label: topLevelOption.label,
            options: topLevelOption.options,
            checked: value.includes(topLevelOption.value),
            opened: false
        };
    })), upperLevelsState = ref3[0], setUpperLevelsState = ref3[1];
    (0,react.useEffect)(function() {
        setUpperLevelsState(topLevelOptions.map(function(topLevelOption) {
            return {
                value: topLevelOption.value,
                label: topLevelOption.label,
                options: topLevelOption.options,
                checked: value.includes(topLevelOption.value),
                opened: false
            };
        }));
    }, [
        topLevelOptions
    ]);
    (0,outside_click/* useOutsideClick */.O)(ref.current, function() {
        setOpened(false);
    });
    var bareOptions = (0,react.useMemo)(function() {
        return topLevelOptions.map(function(topLevelOption) {
            return topLevelOption.options;
        }).flat();
    }, [
        topLevelOptions
    ]);
    var filteredOptions = (0,react.useMemo)(function() {
        if (!searchQuery) return bareOptions;
        var slugifiedSearchQuery = (0,string/* slugify */.lV)(searchQuery);
        return bareOptions.filter(function(option) {
            return (0,string/* slugify */.lV)(option.label).includes(slugifiedSearchQuery);
        });
    }, [
        bareOptions,
        searchQuery
    ]);
    var anyFilteredOptionsAreSelected = (0,react.useMemo)(function() {
        return filteredOptions.filter(function(option) {
            return value.includes(option.value);
        }).length !== 0;
    }, [
        value,
        filteredOptions
    ]);
    var handleToggleClick = function() {
        if (!allowOpen || allowOpen()) setOpened(function(opened) {
            return !opened;
        });
    };
    var handleOptionChange = function(option, type) {
        return function(checked) {
            if (type === "top") {
                var upper = upperLevelsState.find(function(category) {
                    return category.value === option.value;
                });
                var upperIndex = upperLevelsState.findIndex(function(category) {
                    return category.value === option.value;
                });
                if (checked) {
                    onChange((0,_to_consumable_array/* default */.Z)(value).concat((0,_to_consumable_array/* default */.Z)(upper.options.map(function(option) {
                        return option.value;
                    }).filter(function(v) {
                        return !value.includes(v);
                    }))));
                    setUpperLevelsState(function(oldState) {
                        var newState = (0,_to_consumable_array/* default */.Z)(oldState);
                        newState[upperIndex] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, upper), {
                            opened: true
                        });
                        return newState;
                    });
                } else {
                    onChange(value.filter(function(v) {
                        return !upper.options.map(function(option) {
                            return option.value;
                        }).includes(v);
                    }));
                    setUpperLevelsState(function(oldState) {
                        var newState = (0,_to_consumable_array/* default */.Z)(oldState);
                        newState[upperIndex] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, upper), {
                            opened: false
                        });
                        return newState;
                    });
                }
            } else if (type === "inner") {
                if (checked) {
                    if (value.includes(option.value)) return;
                    onChange((0,_to_consumable_array/* default */.Z)(value).concat([
                        option.value
                    ]));
                } else {
                    onChange(value.filter(function(v) {
                        return v !== option.value;
                    }));
                }
            }
        };
    };
    var handleCheckAll = function() {
        onChange((0,_to_consumable_array/* default */.Z)(new Set((0,_to_consumable_array/* default */.Z)(value).concat((0,_to_consumable_array/* default */.Z)(filteredOptions.map(function(param) {
            var value = param.value;
            return value;
        }))))));
    };
    var handleClear = function() {
        var valuesToClear = filteredOptions.map(function(option) {
            return option.value;
        });
        onChange(value.filter(function(v) {
            return !valuesToClear.includes(v);
        }));
        setUpperLevelsState(function(oldState) {
            return oldState.map(function(upper) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, upper), {
                    opened: false
                });
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (filter_two_level_dropdown_module_default()).container,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
                title: "Filter by ".concat(placeholder.toLocaleLowerCase()),
                display: "block",
                size: "sm",
                type: "outline",
                color: value.length > 0 ? "orange" : "greyMedium",
                disabled: disabled,
                onClick: handleToggleClick,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ChevronDownIcon */.v4, {
                    color: value.length > 0 ? "orange" : "greyDark",
                    className: (0,utils/* classNames */.AK)([
                        (filter_two_level_dropdown_module_default()).icon,
                        opened && (filter_two_level_dropdown_module_default()).opened
                    ])
                }),
                iconPlacement: "right",
                children: placeholder
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown_container/* DropdownContainer */.D, {
                opened: opened,
                className: (filter_two_level_dropdown_module_default()).dropdown,
                children: [
                    enableSearch && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_input/* TextInput */.o, {
                                size: "sm",
                                value: searchQuery,
                                placeholder: searchPlaceholder,
                                onChange: setSearchQuery
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* Divider */.i, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: upperLevelsState.map(function(topLevelOption) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (filter_two_level_dropdown_module_default()).topLevelCheckboxes,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(system_checkbox/* Checkbox */.X, {
                                                label: topLevelOption.label,
                                                value: topLevelOption.options.filter(function(option) {
                                                    return value.includes(option.value);
                                                }).length == topLevelOption.options.length,
                                                onChange: onChange && handleOptionChange(topLevelOption, "top")
                                            }, topLevelOption.label),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (filter_two_level_dropdown_module_default()).dropButtonTopLevel,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
                                                    title: topLevelOption.opened ? "Collapse" : "Expand",
                                                    name: "toggle",
                                                    type: "icon",
                                                    onClick: function() {
                                                        setUpperLevelsState(upperLevelsState.map(function(upperLevelOption) {
                                                            if (upperLevelOption.value === topLevelOption.value) {
                                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, upperLevelOption), {
                                                                    opened: !upperLevelOption.opened
                                                                });
                                                            } else {
                                                                return upperLevelOption;
                                                            }
                                                        }));
                                                    },
                                                    children: topLevelOption.opened ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ChevronUpIcon */.g8, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ChevronDownIcon */.v4, {})
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (filter_two_level_dropdown_module_default()).innerCheckboxes,
                                        children: topLevelOption.opened && topLevelOption.options.map(function(option) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(system_checkbox/* Checkbox */.X, {
                                                label: option.amount ? "".concat(option.label, " (").concat(option.amount, ")") : "".concat(option.label),
                                                value: value.includes(option.value),
                                                onChange: onChange && handleOptionChange(option, "inner")
                                            }, option.label);
                                        })
                                    })
                                ]
                            }, topLevelOption.label);
                        })
                    }),
                    filteredOptions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* Divider */.i, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (filter_two_level_dropdown_module_default()).bottomOptions,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
                                        type: "text",
                                        onClick: handleCheckAll,
                                        children: "Check all"
                                    }),
                                    anyFilteredOptionsAreSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
                                        type: "text",
                                        onClick: handleClear,
                                        children: "Clear"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/debounce.tsx
var debounce = __webpack_require__(6701);
// EXTERNAL MODULE: ./src/components/questions/list/toolbar.module.css
var toolbar_module = __webpack_require__(95682);
var toolbar_module_default = /*#__PURE__*/__webpack_require__.n(toolbar_module);
;// CONCATENATED MODULE: ./src/components/questions/list/toolbar.tsx



















var Toolbar = function(param) {
    var questions = param.questions, categories = param.categories, hasFilters = param.hasFilters, clearFilters = param.clearFilters, config = param.config, onConfigChange = param.onConfigChange;
    var permissionRequired = (0,users/* useUpsell */.$n)().permissionRequired;
    var isMobile = (0,is_mobile/* useIsMobile */.d)();
    var ref = (0,react.useState)(false), showFilters = ref[0], setShowFilters = ref[1];
    var debouncedSearchQuery = (0,debounce/* useDebounce */.N)(config.searchQuery, 2000);
    (0,react.useEffect)(function() {
        setShowFilters(!isMobile);
    }, [
        isMobile
    ]);
    (0,react.useEffect)(function() {
        if (debouncedSearchQuery) {
            tracking/* TrackingAPI.questionSearch */.A.questionSearch(config);
        }
    }, [
        debouncedSearchQuery
    ]);
    var positionsOptions = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(new Set(questions.flatMap(function(param) {
            var positions = param.positions;
            return positions.map(function(param) {
                var position = param.position;
                return position;
            });
        }))).map(function(position) {
            return {
                value: position,
                label: position
            };
        }).sort(function(o1, o2) {
            return o1.label.localeCompare(o2.label);
        });
    }, [
        questions
    ]);
    var categoriesOptions = (0,react.useMemo)(function() {
        return categories.map(function(category) {
            return {
                value: category.name,
                label: category.name,
                options: category.question_tags.map(function(tag) {
                    return {
                        label: tag.name,
                        value: tag.name
                    };
                })
            };
        });
    }, [
        categories
    ]);
    var companyOptions = (0,react.useMemo)(function() {
        var companiesCount = new Map();
        questions.forEach(function(param) {
            var companies = param.companies;
            companies.forEach(function(param) {
                var company = param.company;
                companiesCount.set(company, (companiesCount.get(company) || 0) + 1);
            });
        });
        var companiesOptions = (0,_to_consumable_array/* default */.Z)(companiesCount.entries()).sort(function(o1, o2) {
            return o2[1] - o1[1];
        }).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), company = _param[0], count = _param[1];
            return {
                label: "".concat(company, " (").concat(count, ")"),
                value: company
            };
        });
        return companiesOptions;
    }, [
        questions
    ]);
    var handleChange = function(key) {
        return function(value) {
            onConfigChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), (0,_define_property/* default */.Z)({
                page: 0
            }, key, value)));
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (toolbar_module_default()).toolbar,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(text_input/* TextInput */.o, {
                name: "searchQuery",
                size: "sm",
                placeholder: "find a question...",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SearchIcon */.W1, {
                    color: "greyMedium"
                }),
                value: config.searchQuery,
                onChange: handleChange("searchQuery")
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
                size: "sm",
                onClick: function() {
                    return setShowFilters(true);
                },
                children: "Filters"
            }),
            showFilters && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (toolbar_module_default()).filters,
                children: [
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        children: [
                            "Filters",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
                                type: "text",
                                color: "greyMedium",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                                    color: "greyMedium"
                                }),
                                onClick: function() {
                                    return setShowFilters(false);
                                },
                                children: "Close"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTwoLevelDropdown, {
                        placeholder: "Categories",
                        topLevelOptions: categoriesOptions,
                        value: config.tags,
                        onChange: handleChange("tags")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_dropdown/* FilterDropdown */.M, {
                        placeholder: "Positions",
                        options: positionsOptions,
                        value: config.positions,
                        onChange: handleChange("positions"),
                        enableSearch: true,
                        searchPlaceholder: "Filter positions..."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_dropdown/* FilterDropdown */.M, {
                        placeholder: "Difficulty",
                        options: levels/* difficultyLevelOptions */.a8,
                        value: config.levels,
                        onChange: handleChange("levels")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_dropdown/* FilterDropdown */.M, {
                        placeholder: "Companies",
                        options: companyOptions,
                        value: config.companies,
                        enableSearch: true,
                        searchPlaceholder: "Filter companies...",
                        onChange: handleChange("companies"),
                        allowOpen: permissionRequired("question_company_filter", "", {
                            cta: "question.viewCompanies"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_dropdown/* FilterDropdown */.M, {
                        placeholder: "More filters",
                        options: question_list/* extraFilterOptions */.oA,
                        value: config.extraFilters,
                        onChange: handleChange("extraFilters")
                    }),
                    hasFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
                        color: "orangeLight",
                        size: "sm",
                        onClick: clearFilters,
                        children: "clear"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/api/companies.ts
var api_companies = __webpack_require__(23628);
;// CONCATENATED MODULE: ./src/components/questions/list/top_companies.tsx












var TopCompanies = function(param) {
    var config = param.config, maxVisible = param.maxVisible, onConfigChange = param.onConfigChange, companyFilter = param.companyFilter;
    var hasPermission = (0,users/* useAuth */.aC)().hasPermission;
    var showUpsellModal = (0,users/* useUpsell */.$n)().showUpsellModal;
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)([]), companies = ref1[0], setCompanies = ref1[1];
    (0,react.useEffect)(function() {
        var getTopCompanies = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var companies;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                api_companies/* CompaniesAPI.getTopCompanies */.l.getTopCompanies()
                            ];
                        case 1:
                            companies = _state.sent();
                            setCompanies(companies);
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getTopCompanies() {
                return _ref.apply(this, arguments);
            };
        }();
        getTopCompanies();
    }, []);
    var visibleCompanies = (0,react.useMemo)(function() {
        return companies.filter(function(company) {
            return !companyFilter || company.name.toLowerCase().includes(companyFilter.toLowerCase());
        }).slice(0, maxVisible);
    }, [
        companies,
        maxVisible,
        companyFilter
    ]);
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* Spinner */.$, {
        size: "sm",
        text: "Loading top companies"
    });
    if (visibleCompanies.length === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "No companies found."
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(pilltag_group/* PillTagGroup */.s, {
        children: visibleCompanies.map(function(company) {
            var selected = config.companies.includes(company.name);
            var addCompany = function() {
                onConfigChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                    companies: (0,_to_consumable_array/* default */.Z)(config.companies).concat([
                        company.name
                    ]),
                    page: 0
                }));
            };
            var removeCompany = function() {
                onConfigChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                    companies: config.companies.filter(function(c) {
                        return c !== company.name;
                    }),
                    page: 0
                }));
            };
            var handleClick = function() {
                if (hasPermission("question_company_filter")) {
                    if (selected) removeCompany();
                    else addCompany();
                } else {
                    showUpsellModal({
                        cta: "question.viewCompanies"
                    });
                }
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(pilltag/* PillTag */.j, {
                color: selected ? "blue" : "greyLight",
                onClick: handleClick,
                children: company.name
            }, company.name);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/questions/list/top_questions_tags.tsx








var TopQuestionTags = function(param) {
    var questions = param.questions, config = param.config, maxVisible = param.maxVisible, onConfigChange = param.onConfigChange, questionFilter = param.questionFilter;
    var tags = (0,react.useMemo)(function() {
        var counter = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = questions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var question = _step.value;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = question.tags[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var tag = _step1.value;
                        if (!counter[tag.name]) {
                            counter[tag.name] = {
                                count: 0,
                                isPrimary: tag.is_primary
                            };
                        }
                        counter[tag.name].count += 1;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return Object.entries(counter).sort(function(param, param1) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _1 = _param[0], info_1 = _param[1], _param1 = (0,_sliced_to_array/* default */.Z)(param1, 2), _2 = _param1[0], info_2 = _param1[1];
            return info_1.count - info_2.count;
        }).sort(function(param, param1) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _1 = _param[0], info_1 = _param[1], _param1 = (0,_sliced_to_array/* default */.Z)(param1, 2), _2 = _param1[0], info_2 = _param1[1];
            return info_1.isPrimary ? -1 : info_2.isPrimary ? 1 : 0;
        }).sort(function(param, param1) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), tagName_1 = _param[0], _1 = _param[1], _param1 = (0,_sliced_to_array/* default */.Z)(param1, 2), tagName_2 = _param1[0], _2 = _param1[1];
            return config.tags.includes(tagName_1) && !config.tags.includes(tagName_2) ? -1 : 1;
        }).filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), tag = _param[0], _ = _param[1];
            return !questionFilter || questionFilter === "" || tag.toLowerCase().includes(questionFilter.toLowerCase());
        }).slice(0, maxVisible).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), tag = _param[0], _ = _param[1];
            return tag;
        });
    }, [
        questions,
        maxVisible,
        questionFilter,
        config
    ]);
    var pillTags = (0,react.useMemo)(function() {
        return tags.map(function(tag) {
            var selected = config.tags.includes(tag);
            var addQuestionTag = function() {
                onConfigChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                    tags: (0,_to_consumable_array/* default */.Z)(config.tags).concat([
                        tag
                    ]),
                    page: 0
                }));
            };
            var removeQuestionTags = function() {
                onConfigChange((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                    tags: config.tags.filter(function(c) {
                        return c !== tag;
                    }),
                    page: 0
                }));
            };
            var handleClick = function() {
                if (selected) removeQuestionTags();
                else addQuestionTag();
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(pilltag/* PillTag */.j, {
                color: selected ? "blue" : "greyLight",
                onClick: handleClick,
                children: tag
            }, tag);
        });
    }, [
        tags,
        config,
        onConfigChange
    ]);
    return tags.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pilltag_group/* PillTagGroup */.s, {
        children: pillTags
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "No tags found"
    });
};

// EXTERNAL MODULE: ./src/components/questions/list/weekly_goal.tsx + 1 modules
var weekly_goal = __webpack_require__(21795);
;// CONCATENATED MODULE: ./src/components/questions/list/question_list.tsx




























var QuestionList = function(param) {
    var initialQuestions = param.questions, categories = param.categories;
    var isMobile = (0,is_mobile/* useIsMobile */.d)();
    var ref = (0,react.useState)(initialQuestions), questions = ref[0], setQuestions = ref[1];
    var ref1 = (0,users/* useAuth */.aC)(), isReady = ref1.isReady, hasPermission = ref1.hasPermission;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,local_storage_state/* useLocalStorageState */.R)("QUESTIONS_FILTERS2", question_list/* defaultQuestionListConfig */.qT), 2), cachedFilters = ref2[0], setCachedFilters = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,query_string_state/* useQueryStringState */.j)(question_list/* defaultQuestionListConfig */.qT, {
        numberFields: [
            "levels",
            "page",
            "pageSize"
        ]
    }), 2), config = ref3[0], setConfig = ref3[1];
    (0,react.useEffect)(function() {
        setCachedFilters(config);
    }, [
        config
    ]);
    (0,react.useEffect)(function() {
        // Only use cached filters if we don't have explicit filters in the querystring on page load.
        if (!window.location.search) setConfig(cachedFilters);
    }, []);
    (0,react.useEffect)(function() {
        if (isReady && !hasPermission("question_company_filter")) {
            setConfig((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                companies: []
            }));
        }
    }, [
        isReady,
        !hasPermission("question_company_filter")
    ]);
    var ref4 = (0,react.useMemo)(function() {
        return (0,question_list/* applyQuestionListConfig */.fl)(questions, config);
    }, [
        questions,
        config
    ]), filteredQuestions = ref4[0], paginatedQuestions = ref4[1];
    var handleQuestionChange = function(newQuestion) {
        setQuestions(questions.map(function(question) {
            return question.uuid === newQuestion.uuid ? newQuestion : question;
        }));
    };
    var clearFilters = function() {
        setConfig(question_list/* defaultQuestionListConfig */.qT);
    };
    var hasFilters = (0,react.useMemo)(function() {
        var discardFilters = [
            "page",
            "pageSize",
            "orderingDirection"
        ];
        var filters = Object.entries(config).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            if (discardFilters.includes(key)) {
                return false;
            } else if (key === "ordering" && value === question_list/* defaultQuestionListConfig.ordering */.qT.ordering) {
                return false;
            } else if (typeof value === "string" && value.length > 0) {
                return true;
            } else if (typeof value === "number" && value > 0) {
                return true;
            } else if (Array.isArray(value) && value.length > 0) {
                return true;
            }
            return false;
        });
        return filters.some(Boolean);
    }, [
        config
    ]);
    var pageTitle = (0,react.useMemo)(function() {
        var title = [];
        if (config.companies.length === 1) {
            title.push(config.companies[0]);
        } else if (config.positions.length === 1) {
            title.push(config.positions[0]);
        }
        title.push("Interview Questions");
        return title.join(" ");
    }, [
        config
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* MetaTags */.N, {
                title: pageTitle,
                canonical: "/questions",
                prev: config.page > 0 ? "/questions?page=".concat(config.page - 1, "&pageSize=").concat(config.pageSize) : "",
                next: config.page < Math.floor(questions.length / config.pageSize) ? "/questions?page=".concat(config.page + 1, "&pageSize=").concat(config.pageSize) : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (question_list_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: pageTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitQuestionButton, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (question_list_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (question_list_module_default()).mainContent,
                        children: [
                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionCounts, {
                                questions: questions,
                                visibleQuestions: filteredQuestions
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories, {
                                categories: categories,
                                config: config,
                                onConfigChange: setConfig
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky/* Sticky */.L, {
                                shadow: true,
                                disabled: isMobile,
                                zIndexOffset: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (question_list_module_default()).toolbar,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar, {
                                        categories: categories,
                                        questions: questions,
                                        hasFilters: hasFilters,
                                        clearFilters: clearFilters,
                                        config: config,
                                        onConfigChange: setConfig
                                    })
                                })
                            }),
                            paginatedQuestions.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionTable, {
                                        questions: paginatedQuestions,
                                        onQuestionChange: handleQuestionChange,
                                        config: config,
                                        onConfigChange: setConfig
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(question_table_paginator/* QuestionTablePaginator */.$, {
                                        questions: filteredQuestions,
                                        config: config,
                                        onConfigChange: function(config) {
                                            setConfig(config);
                                            window.scrollTo({
                                                top: 0
                                            });
                                        }
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Sorry, there are no questions found."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Try changing or",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(system_button/* Button */.z, {
                                                onClick: clearFilters,
                                                type: "text",
                                                children: "clearing the filters"
                                            }),
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(recommended_questions/* RecommendedQuestions */.o, {
                                        trackingComponent: "emptyQuestionList"
                                    })
                                ]
                            })
                        ]
                    }),
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky/* Sticky */.L, {
                        disabled: isMobile,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (question_list_module_default()).sidebar,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (question_list_module_default()).sidebarContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Quick filters"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* Divider */.i, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickFilters, {
                                        config: config,
                                        onConfigChange: setConfig
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* Divider */.i, {
                                        size: "sm"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(weekly_goal/* QuestionWeekly */.A, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* Divider */.i, {
                                        size: "sm"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Top Companies"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_input/* TextInput */.o, {
                                        name: "sidebarTopCompanyQuery",
                                        size: "sm",
                                        placeholder: "Search for companies...",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SearchIcon */.W1, {
                                            color: "greyMedium"
                                        }),
                                        value: config.searchCompany,
                                        onChange: function(searchTag) {
                                            setConfig((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                                                searchCompany: searchTag
                                            }));
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (question_list_module_default()).BillBox,
                                        "data-sidebar": "topCompanies",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCompanies, {
                                            config: config,
                                            onConfigChange: setConfig,
                                            companyFilter: config.searchCompany
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* Divider */.i, {
                                        size: "sm"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: "Question Tags"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(text_input/* TextInput */.o, {
                                        name: "sidebarQuestionTagQuery",
                                        size: "sm",
                                        placeholder: "Search for questions tags...",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SearchIcon */.W1, {
                                            color: "greyMedium"
                                        }),
                                        value: config.searchQuestionTag,
                                        onChange: function(searchTag) {
                                            setConfig((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config), {
                                                searchQuestionTag: searchTag
                                            }));
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (question_list_module_default()).BillBox,
                                        "data-sidebar": "questionTags",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopQuestionTags, {
                                            maxVisible: 50,
                                            questions: questions,
                                            config: config,
                                            onConfigChange: setConfig,
                                            questionFilter: config.searchQuestionTag
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/questions/list/index.tsx


;// CONCATENATED MODULE: ./src/pages/questions/index.tsx




var QuestionListPage = function(param) {
    var questions = param.questions, categories = param.categories;
    (0,react.useEffect)(function() {
        tracking/* TrackingAPI.questionListViewed */.A.questionListViewed();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionList, {
            categories: categories,
            questions: questions
        })
    });
};
QuestionListPage.layoutConfig = {
    useClarity: true
};
var __N_SSP = true;
/* harmony default export */ var pages_questions = (QuestionListPage);


/***/ }),

/***/ 38194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a8": function() { return /* binding */ difficultyLevelOptions; },
/* harmony export */   "gw": function() { return /* binding */ difficultyLevelColors; },
/* harmony export */   "l9": function() { return /* binding */ difficultyLevels; },
/* harmony export */   "vz": function() { return /* binding */ difficultyLevelNames; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var difficultyLevels = {
    Easy: 1,
    Medium: 2,
    Hard: 3
};
var _obj;
var difficultyLevelNames = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, difficultyLevels.Easy, "Easy"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, difficultyLevels.Medium, "Medium"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, difficultyLevels.Hard, "Hard"), _obj);
var _obj1;
var difficultyLevelColors = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, difficultyLevels.Easy, "green"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, difficultyLevels.Medium, "orange"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, difficultyLevels.Hard, "red"), _obj1);
var difficultyLevelOptions = [
    {
        value: difficultyLevels.Easy,
        label: difficultyLevelNames[difficultyLevels.Easy]
    },
    {
        value: difficultyLevels.Medium,
        label: difficultyLevelNames[difficultyLevels.Medium]
    },
    {
        value: difficultyLevels.Hard,
        label: difficultyLevelNames[difficultyLevels.Hard]
    }, 
];


/***/ }),

/***/ 409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_m": function() { return /* binding */ QuestionListOrderingDirection; },
/* harmony export */   "d0": function() { return /* binding */ QuestionListExtraFilter; },
/* harmony export */   "iM": function() { return /* binding */ QuestionListOrdering; },
/* harmony export */   "xi": function() { return /* binding */ ExperienceLevel; }
/* harmony export */ });
var ExperienceLevel;
(function(ExperienceLevel) {
    ExperienceLevel["All"] = "0";
    ExperienceLevel["Entry"] = "1";
    ExperienceLevel["Student"] = "2";
    ExperienceLevel["MidLevel"] = "3";
    ExperienceLevel["Senior"] = "4";
})(ExperienceLevel || (ExperienceLevel = {}));
var QuestionListExtraFilter;
(function(QuestionListExtraFilter) {
    QuestionListExtraFilter["Saved"] = "Saved";
    QuestionListExtraFilter["Completed"] = "Completed";
    QuestionListExtraFilter["WithSolutions"] = "WithSolutions";
    QuestionListExtraFilter["WithoutSolutions"] = "WithoutSolutions";
    QuestionListExtraFilter["Recent"] = "Recent";
    QuestionListExtraFilter["Popular"] = "Popular";
})(QuestionListExtraFilter || (QuestionListExtraFilter = {}));
var QuestionListOrdering;
(function(QuestionListOrdering) {
    QuestionListOrdering["Recommended"] = "Recommended";
    QuestionListOrdering["Title"] = "Title";
    QuestionListOrdering["Score"] = "Score";
    QuestionListOrdering["SuccessRate"] = "SuccessRate";
    QuestionListOrdering["Difficulty"] = "Difficulty";
})(QuestionListOrdering || (QuestionListOrdering = {}));
var QuestionListOrderingDirection;
(function(QuestionListOrderingDirection) {
    QuestionListOrderingDirection["ASC"] = "ASC";
    QuestionListOrderingDirection["DESC"] = "DESC";
})(QuestionListOrderingDirection || (QuestionListOrderingDirection = {}));


/***/ }),

/***/ 73696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wv": function() { return /* binding */ pageSizeOptions; },
/* harmony export */   "fl": function() { return /* binding */ applyQuestionListConfig; },
/* harmony export */   "oA": function() { return /* binding */ extraFilterOptions; },
/* harmony export */   "qT": function() { return /* binding */ defaultQuestionListConfig; }
/* harmony export */ });
/* unused harmony export orderingOptions */
/* harmony import */ var types_questions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(409);
/* harmony import */ var utils_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97224);


var applyQuestionListConfig = function(questions, config) {
    var slugifiedSearchQuery = (0,utils_string__WEBPACK_IMPORTED_MODULE_1__/* .slugify */ .lV)(config.searchQuery);
    var date = new Date();
    date.setDate(date.getDate() - 90);
    var ninetyDaysAgo = date.toISOString();
    var filtered = questions.filter(function(question) {
        if (slugifiedSearchQuery) {
            var matches = (0,utils_string__WEBPACK_IMPORTED_MODULE_1__/* .slugify */ .lV)(question.title).includes(slugifiedSearchQuery) || question.companies.some(function(param) {
                var company = param.company;
                return (0,utils_string__WEBPACK_IMPORTED_MODULE_1__/* .slugify */ .lV)(company).includes(slugifiedSearchQuery);
            }) || question.type.includes(slugifiedSearchQuery);
            if (!matches) return false;
        }
        if (config.types.length > 0) {
            if (!config.types.includes(question.type)) return false;
        }
        if (config.levels.length > 0) {
            if (!config.levels.includes(question.level)) return false;
        }
        if (config.tags && config.tags.length > 0) {
            var filteredTags = question.tags.filter(function(c) {
                return config.tags.includes(c.name);
            });
            if (filteredTags.length === 0) return false;
        }
        if (config.companies.length > 0) {
            var filteredCompanies = question.companies.filter(function(param) {
                var company = param.company;
                return config.companies.includes(company);
            });
            if (filteredCompanies.length === 0) return false;
        }
        if (config.positions.length > 0) {
            var filteredPositions = question.positions.filter(function(param) {
                var position = param.position;
                return config.positions.includes(position);
            });
            if (filteredPositions.length === 0) return false;
        }
        if (config.extraFilters.length > 0) {
            if (config.extraFilters.includes(types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListExtraFilter.Saved */ .d0.Saved)) {
                if (!question.saved) return false;
            }
            if (config.extraFilters.includes(types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListExtraFilter.Completed */ .d0.Completed)) {
                if (!question.completed) return false;
            }
            if (config.extraFilters.includes(types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListExtraFilter.WithSolutions */ .d0.WithSolutions)) {
                if (!question.has_solution) return false;
            }
            if (config.extraFilters.includes(types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListExtraFilter.WithoutSolutions */ .d0.WithoutSolutions)) {
                if (question.has_solution) return false;
            }
            if (config.extraFilters.includes(types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListExtraFilter.Recent */ .d0.Recent)) {
                if (question.date_asked < ninetyDaysAgo) return false;
            }
            if (config.extraFilters.includes(types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListExtraFilter.Popular */ .d0.Popular)) {
                return question.is_promoted;
            }
        }
        return true;
    }).sort(function(q1, q2) {
        var r = 0;
        if (config.ordering === types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListOrdering.Title */ .iM.Title) {
            r = q1.title.localeCompare(q2.title);
        }
        if (config.ordering === types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListOrdering.Score */ .iM.Score) {
            r = q1.upvotes - q2.upvotes;
        }
        if (config.ordering === types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListOrdering.SuccessRate */ .iM.SuccessRate) {
            r = q1.acceptance_rate - q2.acceptance_rate;
        }
        if (config.ordering === types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListOrdering.Difficulty */ .iM.Difficulty) {
            r = q1.level - q2.level;
        }
        return config.orderingDirection === types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListOrderingDirection.ASC */ ._m.ASC ? r : -r;
    });
    var paginated = filtered.slice(config.pageSize * config.page, config.pageSize * config.page + config.pageSize);
    return [
        filtered,
        paginated
    ];
};
var defaultQuestionListConfig = {
    searchQuery: "",
    types: [],
    levels: [],
    tags: [],
    companies: [],
    positions: [],
    extraFilters: [],
    searchQuestionTag: "",
    searchCompany: "",
    ordering: types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListOrdering.Recommended */ .iM.Recommended,
    orderingDirection: types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListOrderingDirection.ASC */ ._m.ASC,
    pageSize: 20,
    page: 0
};
var extraFilterOptions = [
    {
        value: types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListExtraFilter.Saved */ .d0.Saved,
        label: "Only show questions I've saved"
    },
    {
        value: types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListExtraFilter.Completed */ .d0.Completed,
        label: "Only show questions I've completed"
    },
    {
        value: types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListExtraFilter.WithSolutions */ .d0.WithSolutions,
        label: "Only show questions with solutions"
    },
    {
        value: types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListExtraFilter.WithoutSolutions */ .d0.WithoutSolutions,
        label: "Only show questions without solutions"
    },
    {
        value: types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListExtraFilter.Recent */ .d0.Recent,
        label: "Only show recent questions"
    },
    {
        value: types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListExtraFilter.Popular */ .d0.Popular,
        label: "Only show popular questions"
    }, 
];
var orderingOptions = [
    {
        value: types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListOrdering.Recommended */ .iM.Recommended,
        label: "Recommended"
    },
    {
        value: types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListOrdering.Title */ .iM.Title,
        label: "Title"
    },
    {
        value: types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListOrdering.Score */ .iM.Score,
        label: "Score"
    },
    {
        value: types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListOrdering.SuccessRate */ .iM.SuccessRate,
        label: "Success rate"
    },
    {
        value: types_questions__WEBPACK_IMPORTED_MODULE_0__/* .QuestionListOrdering.Difficulty */ .iM.Difficulty,
        label: "Difficulty"
    }, 
];
var pageSizeOptions = [
    {
        value: 20,
        label: "20"
    },
    {
        value: 50,
        label: "50"
    },
    {
        value: 100,
        label: "100"
    }, 
];


/***/ }),

/***/ 33082:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"na":"acceptance_rate_na__VHsUV"};

/***/ }),

/***/ 51606:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"categories_container__qNGPf"};

/***/ }),

/***/ 87642:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"counts":"question_counts_counts__fsCbp"};

/***/ }),

/***/ 16493:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"question_list_header__kovkX","mainContent":"question_list_mainContent__CPIRR","sidebarContent":"question_list_sidebarContent__6gEXx","container":"question_list_container__zrlhM","BillBox":"question_list_BillBox__m6yyF","sidebar":"question_list_sidebar__oW_Am","toolbar":"question_list_toolbar__MkO_5"};

/***/ }),

/***/ 14339:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"questionContainerPreview":"question_preview_questionContainerPreview__0GRDq","hoverLink":"question_preview_hoverLink__OqH9v","upper":"question_preview_upper__lUsps","modalHeader":"question_preview_modalHeader__AEgTo","modalContainer":"question_preview_modalContainer__YLhi5","questionBodyPreview":"question_preview_questionBodyPreview__12frt","navigate":"question_preview_navigate__FtL92","buttons":"question_preview_buttons__bJIGA"};

/***/ }),

/***/ 58435:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"question_row_link__Y2_OK","score":"question_row_score__0ECy_","actions":"question_row_actions__Bmz9T","companies":"question_row_companies__R14aM","hasIcon":"question_row_hasIcon__mnScq"};

/***/ }),

/***/ 2503:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"question_table_wrapper__ZYYiA","table":"question_table_table__5JBrK","tooltipHeader":"question_table_tooltipHeader__xrKmC","orderBy":"question_table_orderBy__9qMDB"};

/***/ }),

/***/ 70280:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"paginator":"question_table_paginator_paginator__J4msc"};

/***/ }),

/***/ 7133:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"quickFilters":"quick_filters_quickFilters__21Vfd"};

/***/ }),

/***/ 95682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"toolbar_toolbar__Dx0DH","filters":"toolbar_filters__nDSa5"};

/***/ }),

/***/ 85285:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"question_link_list_container__DyAIS","link":"question_link_list_link__YgMDs","content":"question_link_list_content__ILR6a"};

/***/ }),

/***/ 5306:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"content_placeholder_container__1HHjG","line":"content_placeholder_line__GgkD0","shimmer":"content_placeholder_shimmer__0zTdV"};

/***/ }),

/***/ 45062:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__TDBAz","children":"divider_children__Tybyn","sm":"divider_sm__PazsW","md":"divider_md__yK10n","lg":"divider_lg__P_HO8","center":"divider_center__XNVE_","left":"divider_left__bbB4n","right":"divider_right__jS9lw"};

/***/ }),

/***/ 63217:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"filter_two_level_dropdown_container__5rKaA","icon":"filter_two_level_dropdown_icon__dN8LQ","opened":"filter_two_level_dropdown_opened__3mXvH","dropdown":"filter_two_level_dropdown_dropdown__XmB_B","topLevelCheckboxes":"filter_two_level_dropdown_topLevelCheckboxes__PGdV_","dropButtonTopLevel":"filter_two_level_dropdown_dropButtonTopLevel__Qmr7s","innerCheckboxes":"filter_two_level_dropdown_innerCheckboxes__hcQC9","bottomOptions":"filter_two_level_dropdown_bottomOptions__akmV3"};

/***/ }),

/***/ 12195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pilltagGroup":"pilltag_group_pilltagGroup__PQeq8","viewAll":"pilltag_group_viewAll__BagPb"};

/***/ }),

/***/ 82912:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sticky":"sticky_sticky__ijZEX","hasShadow":"sticky_hasShadow__5duxm","topShadow":"sticky_topShadow__uSPN9","bottomShadow":"sticky_bottomShadow__VZHpf"};

/***/ }),

/***/ 97604:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1153,1851,1735,9084,1857,9784,9774,2888,179], function() { return __webpack_exec__(99204); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);